var _line, _path, _path2, _path3, _path4, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadourblogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 17,
    viewBox: "0 0 225 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.000980069,
    y1: 7.5332,
    x2: 90.001,
    y2: 7.51737,
    stroke: "#7F01FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.981 8.73821L108.254 9.50426C108.196 9.5301 108.131 9.53721 108.068 9.52461C108.006 9.512 107.949 9.4803 107.905 9.43398C107.862 9.38765 107.834 9.32903 107.826 9.26634C107.818 9.20365 107.83 9.14006 107.861 9.08451L111.655 2.04105C111.687 1.98136 111.738 1.93394 111.8 1.90638C111.862 1.87882 111.932 1.87271 111.998 1.88904C112.064 1.90537 112.123 1.94319 112.165 1.99643C112.206 2.04968 112.229 2.11528 112.229 2.18271V14.9726C111.473 15.1951 110.723 15.4476 109.981 15.7302V8.73821ZM115.049 8.73821L116.783 9.51685C116.841 9.54381 116.907 9.55176 116.97 9.53959C117.033 9.52741 117.091 9.49572 117.135 9.44907C117.178 9.40242 117.206 9.34323 117.214 9.27998C117.222 9.21674 117.209 9.15271 117.177 9.0971L113.374 2.0421C113.343 1.98241 113.292 1.93499 113.23 1.90743C113.167 1.87987 113.098 1.87376 113.032 1.89009C112.965 1.90642 112.907 1.94424 112.865 1.99748C112.823 2.05073 112.801 2.11633 112.801 2.18376V14.9726C113.558 15.1951 114.307 15.4473 115.049 15.7292V8.73821Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.41 11.1455V15.9727C109.19 16.0536 108.951 16.072 108.721 16.0258C108.491 15.9795 108.278 15.8705 108.107 15.7109C107.936 15.5513 107.814 15.3476 107.754 15.1228C107.693 14.898 107.698 14.6609 107.766 14.4385L108.815 11.0552C108.836 10.9856 108.881 10.9258 108.943 10.8869C109.005 10.848 109.08 10.8326 109.152 10.8436C109.225 10.8546 109.291 10.8912 109.338 10.9467C109.386 11.0022 109.411 11.0728 109.41 11.1455ZM117.27 14.4301L116.218 11.0479C116.197 10.9784 116.152 10.9188 116.09 10.8799C116.028 10.841 115.954 10.8255 115.882 10.8362C115.809 10.8469 115.743 10.8831 115.696 10.9382C115.648 10.9933 115.622 11.0635 115.622 11.136V15.9706C115.844 16.0517 116.083 16.0701 116.314 16.0236C116.545 15.977 116.758 15.8674 116.93 15.7071C117.101 15.5469 117.224 15.3423 117.284 15.1166C117.344 14.891 117.339 14.6531 117.27 14.4301Z",
    fill: "#959595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.985 0H112.801V3.50284H120.985C122.65 3.50284 123.999 2.71895 123.999 1.75142C123.999 0.783889 122.65 0 120.985 0Z",
    fill: "#959595"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.229 0H104.014C102.35 0 101.001 0.783889 101.001 1.75142C101.001 2.71895 102.35 3.50284 104.014 3.50284H112.229V0Z",
    fill: "#959595"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 134.999,
    y1: 7.52539,
    x2: 224.999,
    y2: 7.52539,
    stroke: "#7F01FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadourblogs);
export default __webpack_public_path__ + "static/media/readourblogs.e788272aac15ae25fe5944b1def6d246.svg";
export { ForwardRef as ReactComponent };